<script setup>
import {defineProps} from 'vue';
defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <button class="btn-primary" :class="{ active }">
    <slot/>
  </button>
</template>

<style scoped lang="scss">
.btn-primary {
  background-color: white;
  color: #f97316;
  border: 1px solid #f97316;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.2s;
}
.btn-primary:hover {
  background-color: #f97316;
  color: white;
}
.active {
  background-color: #f97316;
  color: white;
}
.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.5);
}
</style>